import apiHandler from "../core/apiHandler";

const creditNoteApi = apiHandler('credit-note-products');
export default creditNoteApi;
